import { render } from "./MensajeValidacion.vue?vue&type=template&id=6384d362"
import script from "./MensajeValidacion.vue?vue&type=script&lang=js"
export * from "./MensajeValidacion.vue?vue&type=script&lang=js"

import "./MensajeValidacion.vue?vue&type=style&index=0&id=6384d362&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__